const API_KEY = "69dda36967d346305fd46ec967e3072e";
const API_ID = "2da257cb";

export{API_ID, API_KEY}